import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetBranchesReqData } from "./GetBranchesReqData";
import { GetBranchesResData } from "./GetBranchesResData";

const ENDPOINT = "/branch";

export class GetBranchesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: GetBranchesReqData = null;

    constructor(params: GetBranchesReqData = null) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetBranchesResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetBranchesResData(res);
    }
}
